module.exports = __webpack_public_path__ + "img/amex.b93ecab9.svg";